import React from "react";
import { Header, Icons, H1 } from "./style";
import { Icon } from "semantic-ui-react";

const Title = ({ title, padding }) => {
  return (
    <Header padding={padding ? padding : null}>
      <H1>{title}</H1>
      <Icons>
        <h3>VIEW ALL</h3>
        <Icon name='arrow right' className='ico' />
      </Icons>
    </Header>
  );
};

export default Title;
